import React from 'react';

import { ERROR_TITLES, SUCCESS_MESSAGES } from '../../constants';
import { useBoard, useDialogs } from '../../hooks';
import { deleteTaskStatus as apiDeleteTaskStatus } from '../../services/taskStatusService';
import DeleteDialog from './DeleteDialog';

const DIALOG_DESCRIPTION =
  'Tasks assigned to this status will not be automatically reassigned. To assign ' +
  'orphaned tasks, visit the list view.';

const DeleteStatusDialog = () => {
  const { removeStatus } = useBoard();

  const {
    activeStatus,
    handleCloseDeleteStatusDialog: handleClose,
    showDeleteStatusDialog: showDialog,
  } = useDialogs();

  const handleDelete = async (status) => {
    await apiDeleteTaskStatus(status.id);
    removeStatus(status);
  };

  return (
    <DeleteDialog
      description={DIALOG_DESCRIPTION}
      errorTitle={ERROR_TITLES.status.delete}
      isOpen={showDialog}
      item={activeStatus}
      onClose={handleClose}
      onDelete={handleDelete}
      successMessage={SUCCESS_MESSAGES.status.delete}
    />
  );
};

export default DeleteStatusDialog;
